import React from "react";
import { getCurrencyDisplay, type MarketCountry } from "@/config/market";

/**
 * Wraps a price amount with the market's currency symbol, placed before or
 * after per the market's convention — or omitted entirely where the market
 * shows no symbol (NL). Placement comes from `config/market`, so no component
 * decides currency presentation from the language.
 *
 * The symbol is rendered as its own span so callers can style it lighter/
 * smaller than the amount (`symbolClassName`); the amount children should be
 * formatted with `formatPrice(..., excludeCurrency = true)`.
 */
export const CurrencyAmount = ({
  market,
  symbolClassName,
  children,
}: {
  market: MarketCountry;
  symbolClassName?: string;
  children: React.ReactNode;
}) => {
  const { symbol, position } = getCurrencyDisplay(market);
  if (position === "none") return <>{children}</>;
  const symbolEl = <span className={symbolClassName}>{symbol}</span>;
  return position === "before" ? (
    <>
      {symbolEl} {children}
    </>
  ) : (
    <>
      {children} {symbolEl}
    </>
  );
};
